module.exports = __webpack_public_path__ + "img/solo.menu@3x.1f96ae72.png";